export const formatReport = (report) => {
  const attributes = {};
  if (report.title) {
    attributes.title = report.title;
  }
  if (report.pr_comercial) {
    attributes.r_comercial = report.pr_comercial;
  }
  if (report.pr_juridico) {
    attributes.r_juridico = report.pr_juridico;
  }
  if (report.pr_financiero) {
    attributes.r_financiero = report.pr_financiero;
  }
  if (report.pr_riesgos) {
    attributes.r_riesgos = report.pr_riesgos;
  }
  if (report.pr_final) {
    attributes.r_valoracion_final = report.pr_final;
  }
  const id = report.id && report.id !== 'dummy' ? report.id : undefined;

  return {
    data: {
      type: 'node--report',
      attributes,
      id,
    },
  };
};
export const formatPreReport = (report) => {
  const attributes = {};
  if (report.title) {
    attributes.title = report.title;
  }
  if (report.pr_comercial) {
    attributes.pr_comercial = report.pr_comercial;
  }
  if (report.pr_juridico) {
    attributes.pr_juridico = report.pr_juridico;
  }
  if (report.pr_financiero) {
    attributes.pr_financiero = report.pr_financiero;
  }
  if (report.pr_final) {
    attributes.pr_valoracion_final = report.pr_final;
  }
  const id = report.id && report.id !== 'dummy' ? report.id : undefined;

  return {
    data: {
      type: report.type || 'node--report',
      attributes,
      id,
    },
  };
};
export const processReport = (data) => {
  let reportModel = null;
  if (data) {
    reportModel = {};
    reportModel.id = data.id;
    reportModel.type = data.type;
    const { attributes } = data;
    if (attributes.title) {
      reportModel.title = attributes.title;
    }
    if (attributes.r_comercial) {
      reportModel.pr_comercial = attributes.r_comercial;
    }
    if (attributes.r_juridico) {
      reportModel.pr_juridico = attributes.r_juridico;
    }
    if (attributes.r_financiero) {
      reportModel.pr_financiero = attributes.r_financiero;
    }
    if (attributes.r_riesgos) {
      reportModel.pr_riesgos = attributes.r_riesgos;
    }
    if (attributes.r_valoracion_final) {
      reportModel.pr_valoracion_final = attributes.r_valoracion_final;
    }
  }
  return reportModel;
};

export const processPreReport = (data) => {
  let preReportModel = null;
  if (data) {
    preReportModel = {};
    preReportModel.id = data.id;
    preReportModel.type = data.type;
    const { attributes } = data;
    if (attributes.title) {
      preReportModel.title = attributes.title;
    }
    if (attributes.pr_comercial) {
      preReportModel.pr_comercial = attributes.pr_comercial;
    }
    if (attributes.pr_juridico) {
      preReportModel.pr_juridico = attributes.pr_juridico;
    }
    if (attributes.pr_financiero) {
      preReportModel.pr_financiero = attributes.pr_financiero;
    }
    if (attributes.pr_valoracion_final) {
      preReportModel.pr_valoracion_final = attributes.pr_valoracion_final;
    }
  }
  return preReportModel;
};



// WEBPACK FOOTER //
// ./src/features/reports/utils.js